// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero-container {
    position: relative;
    max-width: 100%;
    height: auto;
    max-height:600px;
    overflow: hidden;
    margin-left: auto;
    margin-right: auto;
    align-items:center;
    margin-left: auto;
    margin-right: auto;
    display: flex; /* Add this to center content */
    justify-content: center; /* Center horizontally */
    align-items: center; /* Center vertically */
}

.hero-container img {
    width: 100%;
    height: auto;
    display: block;
}

.overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    pointer-events: none;
}

.hero-welcome-message {
    background-color:transparent;
    font-size:46px;
    position:absolute;
    color:white;
}

.resume-button {
    color: white;
    background-color: rgb(0, 157, 255);
    border: none;
    font-family: 'Courier New', Courier, monospace;
    font-size: 21px;
    border-radius: 30%;
    padding: 20px 40px;
    cursor: pointer;
    position: absolute; /* Ensure it's on top of the image */
    bottom: 20px; /* Distance from the bottom */
    left: 50%; /* Center horizontally */
    transform: translateX(-50%); /* Adjust for actual center position */
    z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./src/components/HeroComponent.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa,EAAE,+BAA+B;IAC9C,uBAAuB,EAAE,wBAAwB;IACjD,mBAAmB,EAAE,sBAAsB;AAC/C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;IACd,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,kCAAkC;IAClC,YAAY;IACZ,8CAA8C;IAC9C,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB,EAAE,oCAAoC;IACxD,YAAY,EAAE,6BAA6B;IAC3C,SAAS,EAAE,wBAAwB;IACnC,2BAA2B,EAAE,sCAAsC;IACnE,UAAU;AACd","sourcesContent":[".hero-container {\n    position: relative;\n    max-width: 100%;\n    height: auto;\n    max-height:600px;\n    overflow: hidden;\n    margin-left: auto;\n    margin-right: auto;\n    align-items:center;\n    margin-left: auto;\n    margin-right: auto;\n    display: flex; /* Add this to center content */\n    justify-content: center; /* Center horizontally */\n    align-items: center; /* Center vertically */\n}\n\n.hero-container img {\n    width: 100%;\n    height: auto;\n    display: block;\n}\n\n.overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    pointer-events: none;\n}\n\n.hero-welcome-message {\n    background-color:transparent;\n    font-size:46px;\n    position:absolute;\n    color:white;\n}\n\n.resume-button {\n    color: white;\n    background-color: rgb(0, 157, 255);\n    border: none;\n    font-family: 'Courier New', Courier, monospace;\n    font-size: 21px;\n    border-radius: 30%;\n    padding: 20px 40px;\n    cursor: pointer;\n    position: absolute; /* Ensure it's on top of the image */\n    bottom: 20px; /* Distance from the bottom */\n    left: 50%; /* Center horizontally */\n    transform: translateX(-50%); /* Adjust for actual center position */\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
